import { render, staticRenderFns } from "./exportSkuStorageFee.vue?vue&type=template&id=0fac0eae&scoped=true&"
import script from "./exportSkuStorageFee.vue?vue&type=script&lang=js&"
export * from "./exportSkuStorageFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac0eae",
  null
  
)

export default component.exports